// This is a helper service that aids any template manipulation required that deals with the
// solution listing provided by AEM
export default class DictionaryService {
  /* @ngInject */
  constructor(ConfigurationService) {
    this.authorable = ConfigurationService.getConfiguration();
  }

  solutionDictionaryLookup(solution, targetKey) {
    const dictionary = this.authorable.SolutionDictionary;
    const solutionMetadata = dictionary[solution];

    return solutionMetadata && solutionMetadata[targetKey];
  }

  expertTypeLookup(type) {
    const dictionary = this.authorable.ExpertDictionary;

    return dictionary[type];
  }

  industryLookup(industryKey) {
    const dictionary = this.authorable.landing_industries;
    const foundIndustry = dictionary.find(industry => industry.key === industryKey);
    return foundIndustry ? foundIndustry.name : undefined;
  }

}




// WEBPACK FOOTER //
// ./src/services/dictionary.service.js